// extracted by mini-css-extract-plugin
module.exports = {"about-css":"About_about-css_3iSdZ","about-logo":"About_about-logo_240tp","about-subject":"About_about-subject_1FFpC","headerTop-basket":"About_headerTop-basket_2YlPu"};